import GMaps from '../libs/gmaps/gmaps.min.js'
import MarkerClusterer from '@google/markerclustererplus'

export const agenciesPage = {
  situation_map: false,

  buildMap: function () {
    const $map = $('#map')
    const datas = {}
    const markers = []
    let map
    let center

    if ($map.find('input[name="department"]').length) datas.department = $map.find('input[name="department"]').val()
    $.ajax({
      type: 'POST',
      dataType: 'json',
      url: document.location.origin + '/agences/listing',
      data: datas,
      success: function (response) {
        let countAgencies = 0
        let marker
        const icon = document.location.origin + '/assets/img/icons/map-marker.png'

        // affiche les agences
        if (typeof (response.agencies) !== 'undefined') {
          /* global google */
          center = new google.maps.LatLng(49.8734224, 2.2781446)
          map = new google.maps.Map($map[0], {
            zoomControl: true,
            center: center,
            scrollwheel: false,
            streetViewControl: false,
            panControl: false,
            mapTypeControl: false,
            draggable: true,
            disableDoubleClickZoom: false,
            keyboardShortcuts: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP
          })
        }

        $.each(response.agencies, function (i, elem) {
          countAgencies++
          marker = new google.maps.Marker({
            position: new google.maps.LatLng(elem.agency_lat, elem.agency_lon),
            icon: icon,
            title: elem.agency_name,
            link: elem.agency_slug,
            textColor: '#ffffff'
          })
          markers.push(marker)
          google.maps.event.addListener(marker, 'click', function () { document.location.href = '/agences/' + this.link })
        })

        const clusterStyles = [
          {
            textColor: '#fff',
            textSize: '16',
            fontFamily: 'Montserrat',
            url: document.location.origin + '/assets/img/icons/m1.png',
            height: 52,
            width: 51
          },
          {
            textColor: '#fff',
            textSize: '16',
            fontFamily: 'Montserrat',
            url: document.location.origin + '/assets/img/icons/m2.png',
            height: 56,
            width: 55
          },
          {
            textColor: '#fff',
            textSize: '16',
            fontFamily: 'Montserrat',
            url: document.location.origin + '/assets/img/icons/m3.png',
            height: 65,
            width: 64
          },
          {
            textColor: '#fff',
            textSize: '16',
            fontFamily: 'Montserrat',
            url: document.location.origin + '/assets/img/icons/m4.png',
            height: 78,
            width: 77
          },
          {
            textColor: '#fff',
            textSize: '16',
            fontFamily: 'Montserrat',
            url: document.location.origin + '/assets/img/icons/m5.png',
            height: 90,
            width: 89
          }
        ]

        // dessine la carte ou affiche un message
        if (countAgencies > 0) {
          const m = new MarkerClusterer(map, markers, {
            styles: clusterStyles
            // imagePath: 'assets/img/icons/m',
          })
          if (countAgencies === 1) {
            const listener = google.maps.event.addListener(map, 'idle', function () {
              m.fitMapToMarkers()
              map.setZoom(10)
              google.maps.event.removeListener(listener)
            })
          } else {
            const listener = google.maps.event.addListener(map, 'idle', function () {
              m.fitMapToMarkers()
              map.setZoom(7)
              google.maps.event.removeListener(listener)
            })
          }
        } else {
          $map.html('<div class="alert alert-light text-center" role="alert">Aucune agence disponible pour les critères demandés.</div>')
        }
      }
    })
  },

  init: function () {
    if ($('#map').length) {
      this.buildMap()
    } else if ($('#map-detail').length) {
      const $map = $('#map-detail')
      $map.waypoint(function () {
        // console.log(this.element.id + ' hit')
        const map = new GMaps({
          div: '#' + $map.attr('id'),
          scrollwheel: false,
          lat: $map.attr('map-lat'),
          lng: $map.attr('map-lng')
        })
        const marker = map.addMarker({
          lat: $map.attr('map-lat'),
          lng: $map.attr('map-lng'),
          title: $map.attr('map-title')
        })
        marker.setAnimation(google.maps.Animation.BOUNCE)
        this.destroy()
      }, {
        offset: '100%'
      })
    }
  }

}
